import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@nexus/ui"

/** Column count for active/completed opportunity rows (no job-status column). */
export const OPPORTUNITIES_TABLE_SKELETON_COLUMN_COUNT = 8

/** Varied header widths to reflect actual column proportions. */
const HEADER_WIDTHS = ["w-6", "w-16", "w-24", "w-32", "w-48", "w-12", "w-16", "w-36", "w-20"]

/** Varied cell widths per column index for realistic skeleton rows. */
const CELL_WIDTHS = ["w-4", "w-14", "w-20", "w-full", "w-4/5", "w-8", "w-12", "w-3/4", "w-16"]

export function OpportunitiesTableSkeletonBodyRows({
  columnCount,
  rowCount,
}: {
  columnCount: number
  rowCount: number
}) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, i) => (
        <TableRow key={i}>
          {Array.from({ length: columnCount }).map((_, j) => (
            <TableCell key={j}>
              <Skeleton className={`h-4 ${CELL_WIDTHS[j % CELL_WIDTHS.length]}`} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  )
}

export function OpportunitiesTableFullSkeleton({
  columnCount = OPPORTUNITIES_TABLE_SKELETON_COLUMN_COUNT,
  bodyRowCount = 5,
}: {
  columnCount?: number
  bodyRowCount?: number
}) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          {Array.from({ length: columnCount }).map((_, i) => (
            <TableHead key={i}>
              <Skeleton className={`h-3 ${HEADER_WIDTHS[i % HEADER_WIDTHS.length]}`} />
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        <OpportunitiesTableSkeletonBodyRows columnCount={columnCount} rowCount={bodyRowCount} />
      </TableBody>
    </Table>
  )
}
